export const DASHBOARD_HOST = 'dashboard.jjuma.com';
export const PAY_HOST = 'pay.jjuma.com';
export const SHOP_HOST = 'shop.jjuma.com';
export const LINK_HOST = 'link.jjuma.com';
export const BUSINESS_HOST = 'business.jjuma.com';
export const DOC_HOST = 'doc.jjuma.com';
export const MAIN_HOSTS = new Set(['jjuma.com', 'www.jjuma.com']);

export const DASHBOARD_ROUTE_PREFIXES = [
  '/dashboard',
  '/admin',
];

export const DASHBOARD_ROUTE_EXACT = new Set([
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/account',
  '/settings',
  '/kyc',
  '/transactions',
  '/payment-links',
  '/qr-codes',
  '/business-profile',
  '/api-keys',
  '/withdrawals',
  '/bank-details',
  '/verification',
  '/profile',
  '/notifications',
  '/documentation',
  '/team',
]);

export const PUBLIC_PAYMENT_ROUTE_PREFIXES = [
  '/p/',
  '/pay/',
  '/checkout/',
  '/invoice/',
  '/quotation/',
  '/quote/',
  '/receipt/',
];

export const PUBLIC_PAYMENT_ROUTE_EXACT = new Set([
  '/success',
  '/failed',
  '/cancelled',
  '/payment-success',
  '/payment-failed',
  '/payment-cancelled',
]);

export function normalizePath(pathname = '/') {
  return pathname || '/';
}

export function isDashboardRoute(pathname = '/') {
  const path = normalizePath(pathname);
  return DASHBOARD_ROUTE_EXACT.has(path) || DASHBOARD_ROUTE_PREFIXES.some(prefix => path === prefix || path.startsWith(`${prefix}/`));
}

export function isPublicPaymentRoute(pathname = '/') {
  const path = normalizePath(pathname);
  return PUBLIC_PAYMENT_ROUTE_EXACT.has(path) || PUBLIC_PAYMENT_ROUTE_PREFIXES.some(prefix => path.startsWith(prefix));
}

export function buildDomainUrl(base, pathname = '/', search = '', hash = '') {
  const path = normalizePath(pathname);
  const query = search || '';
  const fragment = hash || '';
  return `${base}${path}${query}${fragment}`;
}

export function getDashboardUrl(pathname = '/', search = '', hash = '') {
  return buildDomainUrl(`https://${DASHBOARD_HOST}`, pathname, search, hash);
}

export function getPayUrl(pathname = '/', search = '', hash = '') {
  return buildDomainUrl(`https://${PAY_HOST}`, pathname, search, hash);
}

export function getShopUrl(pathname = '/', search = '', hash = '') {
  return buildDomainUrl(`https://${SHOP_HOST}`, pathname, search, hash);
}

export function getLinkUrl(pathname = '/', search = '', hash = '') {
  return buildDomainUrl(`https://${LINK_HOST}`, pathname, search, hash);
}

export function getBusinessUrl(pathname = '/', search = '', hash = '') {
  return buildDomainUrl(`https://${BUSINESS_HOST}`, pathname, search, hash);
}

export function getDocsUrl(pathname = '/', search = '', hash = '') {
  return buildDomainUrl(`https://${DOC_HOST}`, pathname, search, hash);
}
